const ClearFilters = ({ setSearch, setSubmissionData, submissionsDataCache, setPagingState }) => {
    const handleClearFilters = event => {
        event.preventDefault();
        setSearch({});
        sessionStorage.setItem('search', '{}');

        setSubmissionData(submissionsDataCache);
        sessionStorage.setItem('SubmissionData', JSON.stringify(submissionsDataCache));
        setPagingState(1, submissionsDataCache);
    };
    return (
        <a href="/" onClick={handleClearFilters} className="nhs-link">
            Clear Filters
        </a>
    );
};

export default ClearFilters;
